var map = {
	"./dashboard/index.vue": "9406",
	"./document/index.vue": "a85d",
	"./errors/index.vue": "0618",
	"./excel-convert/index.vue": "77d2",
	"./image-watermark/index.vue": "8e24",
	"./material-code/index.vue": "8bbf",
	"./qrcode-decoder/index.vue": "ebf2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af72";